import { render, staticRenderFns } from "./ExpenseView.vue?vue&type=template&id=549a5140&"
import script from "./ExpenseView.vue?vue&type=script&lang=js&"
export * from "./ExpenseView.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseView.vue?vue&type=style&index=0&id=549a5140&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports